type IconProps = { className?: string };

const baseSvg = (d: string | string[]) => {
  const paths = Array.isArray(d) ? d : [d];
  return ({ className }: IconProps) => (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
    >
      {paths.map((path, i) => (
        <path key={i} strokeLinecap="round" strokeLinejoin="round" d={path} />
      ))}
    </svg>
  );
};

export const ArrowsRightLeftIcon = baseSvg(
  'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
);
export const ArrowRightIcon = baseSvg('M14 5l7 7m0 0l-7 7m7-7H3');
export const ArrowLeftIcon = baseSvg('M11 17l-5-5m0 0l5-5m-5 5h12');
export const PlusIcon = baseSvg('M12 4v16m8-8H4');
export const TrashIcon = baseSvg(
  'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16',
);
export const ClockIcon = baseSvg('M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z');
export const TruckIcon = baseSvg(
  'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
);
export const CheckCircleIcon = baseSvg('M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z');
export const CheckIcon = baseSvg('M5 13l4 4L19 7');
export const BanIcon = baseSvg(
  'M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636',
);
export const EyeIcon = baseSvg([
  'M15 12a3 3 0 11-6 0 3 3 0 016 0z',
  'M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z',
]);
export const PackageIcon = baseSvg([
  'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
]);
export const AlertTriangleIcon = baseSvg(
  'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
);
export const LockIcon = baseSvg(
  'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
);
